export default __webpack_public_path__ + "static/media/zoom-in.64936153.svg";